export const SET_CSOSN_COLLECTION = 'CSOSN/SET_CSOSN_COLLECTION';
